




















































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import {
  FailuresRiskPicker,
  FailuresAccordion,
  FailuresRiskValue,
  FailuresInfo,
  AdvisorIcon
} from "@dsm/dsm-storybook";
import {
  riskAnalysisIncorrectValue,
  RiskAnalysisItem
} from "@/interfaces/questions";

@Component({
  components: {
    FailuresRiskPicker,
    FailuresAccordion,
    FailuresRiskValue,
    FailuresInfo,
    AdvisorIcon
  }
})
export default class RiskPickerForm extends Vue {
  @Prop({ type: Number })
  number!: number;
  @Prop({ type: String })
  title!: string;

  @Prop({ type: Array(String) })
  labels!: string[];

  @Prop({ type: Array(Object) })
  analysisItems!: RiskAnalysisItem[] | null;

  rowLabels = [
    {
      title: "Probability",
      valueLabels: ["Very low", "Low", "Moderate", "High", "Very high"]
    },
    {
      title: "Severity",
      valueLabels: ["Very low", "Low", "Moderate", "High", "Very high"]
    },
    {
      title: "Detectibility",
      valueLabels: ["Very low", "Low", "Moderate", "High", "Very high"]
    }
  ];

  info = [
    [
      "Failure is eliminated through preventive control.",
      "No observed or only isolated failures associated with almost identical design or in design simulation and testing.",
      "Isolated, occasional or frequent failures associated with similar designs or in design simulation and testing",
      "Failure is uncertain, likely or inevitable with new design, new application, or change in duty cycle/operating conditions",
      "New technology/new design with no history"
    ],
    [
      "No effect",
      "Annoyance",
      "Loss or degradation of Secondary function",
      "Loss or degradation of Primary function",
      "Failure to meet safety and/or regulatory requirements"
    ],
    [
      "No detection opportunity",
      "Not likely to detect at any stage",
      "Via internal tests",
      "Via internal and customer tests",
      "Failure cannot occur. Prevented through design solutions such as proven design standard, best practice or common material"
    ]
  ]

  answers: Array<RiskAnalysisItem> = [];

  mounted() {
    const items = this.analysisItems;
    if (items !== null) {
      for (let i = 0; i < this.labels.length; i++) {
        Vue.set(this.answers, i, items[i]);
      }
    }
  }

  get isFullyFilled() {
    const tmp =
      this.answers.filter(
        item =>
          item.severity === riskAnalysisIncorrectValue ||
          item.detectability === riskAnalysisIncorrectValue ||
          item.probability === riskAnalysisIncorrectValue
      ).length == 0;
    return tmp;
  }

  @Watch("labels")
  onLabelsChanged() {
    this.resetAnswers();
  }

  @Watch("analysisItems")
  onAnalysisItemsChanged() {
    const items = this.analysisItems;
    if (items !== null) {
      for (let i = 0; i < this.labels.length; i++) {
        Vue.set(this.answers, i, items[i]);
      }
    }
  }

  getRiskAnalysisItemPropertyValue(
    riskAnalysisItem: RiskAnalysisItem,
    propertyIndex: number
  ) {
    if (propertyIndex == 0) {
      return riskAnalysisItem.probability;
    } else if (propertyIndex == 1) {
      return riskAnalysisItem.severity;
    } else if (propertyIndex == 2) {
      return riskAnalysisItem.detectability;
    } else {
      return riskAnalysisIncorrectValue;
    }
  }

  valueChanged(
    riskAnalysisItem: RiskAnalysisItem,
    propertyIndex: number,
    value: number
  ) {
    if (propertyIndex == 0) {
      riskAnalysisItem.probability = value;
    } else if (propertyIndex == 1) {
      riskAnalysisItem.severity = value;
    } else if (propertyIndex == 2) {
      riskAnalysisItem.detectability = value;
    }
  }

  resetAnswers() {
    if (this.analysisItems == null) {
      this.answers = [];
      for (let i = 0; i < this.labels.length; i++) {
        // this.answers.push(emptyRiskAnalysis);
        Vue.set(this.answers, i, {
          probability: riskAnalysisIncorrectValue,
          severity: riskAnalysisIncorrectValue,
          detectability: riskAnalysisIncorrectValue
        } as RiskAnalysisItem);
      }
    } else {
      const items = this.analysisItems;
      if (items !== null) {
        for (let i = 0; i < this.labels.length; i++) {
          Vue.set(this.answers, i, items[i]);
      }
    }
  }
  }
}
